module.exports = [
	{
		"title": "Sentry®Safe Security Family Video",
		"category": "Self-Help",
		"tag": "Self-Help X014E X041E X055 X075 X105 X105P X125",
		"youtubeId": "tpdsPkgmH8c"
	},
	{
		"title": "Sentry®Safe Fire/Water Chest and File Video",
		"category": "Self-Help",
		"tag": "Self-Help CFW20201, CFW20221 CFW30200 CHW20101 CHW20105 CHW20201 CHW20205 CHW20121 CHW20221 CHW30100 CHW30102 CHW30200 CHW30220 FHW40100 FHW40102 FHW40120 FHW40200 FHW40202 FHW40220 FHW41100 HD4100 H0100 HD2100",
		"youtubeId": "5YP42I47j5Q"
	},
	{
		"title": "Sentry®Safe Fire Chest and File Video",
		"category": "Self-Help",
		"tag": "Self-Help 0500 1160 1170 1200 1210",
		"youtubeId": "wT1yUOiWVxA"
	},
	{
		"title": "Sentry®Safe Fire/Water Resistant 1-Hour Safes vs Competition",
		"category": "Self-Help",
		"tag": "Self-Help Education",
		"youtubeId": "Ur_9A62CNrM"
	},
	{
		"title": "How to Remove the Shipping Screw on Your Sentry®Safe Fire Safe",
		"category": "Getting Started",
		"tag": "Getting Started SF123CS SF123ES SF205CV SF205EV SFW082CTB SFW082D SFW082DTB SFW082ESB SFW082ET SFW082F SFW082FTC SFW082GTC SFW123BDC SFW123BSC SFW123BTC SFW123BUC SFW123CS SFW123CSB SFW123CTB SFW123CU SFW123DEB SFW123DSB SFW123DTB SFW123DUB SFW123ES SFW123EU SFW123FSC SFW123FTC SFW123FUL SFW123GDC SFW123GDF SFW123GSC SFW123GTC SFW123GTF SFW123TSC SFW123TTC SFW123UDC SFW123UTC SFW123UVC SFW205BPC SFW205BRC SFW205BWC SFW205BXC SFW205CWB SFW205CZB SFW205DPB SFW205EVB SFW205FWC SFW205FYC SFW205GPC SFW205GQC SFW205GRC SFW205TWC SFW205TXC SFW205UPC SFW205UQC SFW205URC STW123GDC STW123GTC STW205GYC",
		"youtubeId": "kG4WOiRT6Jc"
	},
	{
		"title": "How to Open a Sentry®Safe Combination Dial Fire Safe, with Right-Left, Right Sequence",
		"category": "Self-Help",
		"tag": "Self-Help SF123CS SF205CV SF205CV SFW123CS SFW123CSB SFW123CTB SFW123CU SFW205CWB SFW205CZB",
		"youtubeId": "qQ3er01mg5c"
	},
	{
		"title": "How to Open a Sentry®Safe Electronic Lock Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SF123ES SF205EV SFW082ESB SFW082ET SFW082F SFW082FTC SFW123ES SFW123EU SFW123FSC SFW123FTC SFW123FUL SFW205EVB SFW205FWC SFW205FYC",
		"youtubeId": "oF_h2h-8yR8"
	},
	{
		"title": "How to Open a Sentry®Safe Electronic Lock and Dual Key Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SFW082GTC SFW123GDC SFW123GDF SFW123GSC SFW123GTC SFW123GTF SFW205GPC SFW205GQC SFW205GRC STW123GDC STW123GTC STW205GYC",
		"youtubeId": "mAxY3FH7saM"
	},
	{
		"title": "How to Open a Sentry®Safe Electronic Lock with Dual Key and Fingerprint Scanner Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SFW123BDC SFW123BSC SFW123BTC SFW123BUC SFW205BPC SFW205BRC SFW205BWC SFW205BXC",
		"youtubeId": "uGgPMTKJbpo"
	},
	{
		"title": "How to Open a Sentry®Safe Touch Screen Lock Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SFW123TSC SFW123TTC SFW205TWC SFW205TXC",
		"youtubeId": "WORuh-HT_6I"
	},
	{
		"title": "How to Open a Sentry®Safe Touch Screen Lock and Dual Key Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SFW123UDC SFW123UTC SFW123UVC SFW205UPC SFW205UQC SFW205URC",
		"youtubeId": "Yu2H7fde_Fw"
	},
	{
		"title": "How to Program Codes on Your Sentry®Safe Electronic Lock Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SF123ES SF205EV SFW082ESB SFW082ET SFW082F SFW082FTC SFW082GTC SFW123ES SFW123EU SFW123FSC SFW123FTC SFW123FUL SFW123GDC SFW123GDF SFW123GSC SFW123GTC SFW123GTF SFW205EVB SFW205FWC SFW205FYC SFW205GPC SFW205GQC SFW205GRC STW123GDC STW123GTC STW205GYC",
		"youtubeId": "zBnmwPdWUNI"
	},
	{
		"title": "How to Program Your Fingerprint on a Sentry®Safe Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SFW123BDC SFW123BSC SFW123BTC SFW123BUC SFW205BPC SFW205BRC SFW205BWC SFW205BXC",
		"youtubeId": "EuXAx1RL958"
	},
	{
		"title": "How to Program Codes on Your Sentry®Safe Touch Screen Lock Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SFW123TSC SFW123TTC SFW123UDC SFW123UTC SFW123UVC SFW205TWC SFW205TXC SFW205UPC SFW205UQC SFW205URC",
		"youtubeId": "8Sd3hgi3r7U"
	},
	{
		"title": "How to Change the Batteries on Your Sentry®Safe Electronic Lock Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SF123ES SF205EV SFW082ESB SFW082ET SFW082F SFW082FTC SFW082GTC SFW123BDC SFW123BSC SFW123BTC SFW123BUC SFW123ES SFW123EU SFW123FSC SFW123FTC SFW123FUL SFW123GDC SFW123GDF SFW123GSC SFW123GTC SFW123GTF SFW205BPC SFW205BRC SFW205BWC SFW205BXC SFW205EVB SFW205FWC SFW205FYC SFW205GPC SFW205GQC SFW205GRC STW123GDC STW123GTC STW205GYC",
		"youtubeId": "ZLjf7QeNFPA"
	},
	{
		"title": "How to Change or Jump Batteries on Your Sentry®Safe Touch Screen Lock Fire Safe",
		"category": "Self-Help",
		"tag": "Self-Help SFW123TSC SFW123TTC SFW123UDC SFW123UTC SFW123UVC SFW205TWC SFW205TXC SFW205UPC SFW205UQC SFW205URC",
		"youtubeId": "TvMLBTWJEfE"
	},
	{
		"title": "Small Privacy Lock Chest 1200 from Sentry®Safe",
		"category": "Products",
		"tag": "Products 1200",
		"youtubeId": "RUFauKPsczQ"
	},
	{
		"title": "Medium Chest from Sentry®Safe in 60 Seconds",
		"category": "Products",
		"tag": "Products CHW20201",
		"youtubeId": "uyU1e46N9O4"
	},
	{
		"title": "Large File from Sentry®Safe in 60 Seconds",
		"category": "Products",
		"tag": "Products FHW40120",
		"youtubeId": "Au-ar1SteoM"
	},
	{
		"title": "Sentry®Safe Fire-Safe H0100",
		"category": "Products",
		"tag": "Products H0100",
		"youtubeId": "XOTLyjp8g2M"
	},
	{
		"title": "Waterproof Fire-Resistant File HD4100 from Sentry®Safe",
		"category": "Products",
		"tag": "Products HHD4100",
		"youtubeId": "eRVhr_gmcpM"
	},
	{
		"title": "Portable Security Chest P005C from Sentry®Safe",
		"category": "Products",
		"tag": "Products P005C",
		"youtubeId": "kl1-W6MYicU"
	},
	{
		"title": "Portable Pistol Safe from Sentry®Safe",
		"category": "Products",
		"tag": "Products PP1K",
		"youtubeId": "icUKxu48B0E"
	},
	{
		"title": "Large Commercial Fire Resistant Safe from Sentry®Safe",
		"category": "Products",
		"tag": "Products S8771",
		"youtubeId": "_oeawqWwtVk"
	},
	{
		"title": "Extra Large Digital Biometric Safe from Sentry®Safe",
		"category": "Products",
		"tag": "Products SFW123BDC SFW123BSC SFW123BTC SFW123BUC",
		"youtubeId": "YAnMZhJBFIQ"
	},
	{
		"title": "Extra Large Combination Fire/Water Resistant Safe from Sentry®Safe",
		"category": "Products",
		"tag": "Products SFW123CS SFW123CSB SFW123CTB",
		"youtubeId": "BRMl12y2EJ0"
	},
	{
		"title": "Extra Large Water/Fire Resistant Digital Safe from Sentry®Safe",
		"category": "Products",
		"tag": "Products SFW123ES SFW123FSC SFW123FTC",
		"youtubeId": "J2cX-5fILQk"
	},
	{
		"title": "Sentry®Safe XX-Large Water/Fire-Resistant Safe",
		"category": "Products",
		"tag": "Products SSFW205BXC SFW205FWC SFW205FYC",
		"youtubeId": "KjphZ0gGPAQ"
	},
	{
		"title": "Sentry®Safe Biometric Pistol Safes - Program/Delete Fingerprints",
		"category": "Self-Help",
		"tag": "Self-Help QAP1BE",
		"youtubeId": "ZXSl83gzltE"
	},
	{
		"title": "Sentry®Safe Pistol Safes - Program User Codes",
		"category": "Self-Help",
		"tag": "Self-Help QAP1BE QAP1E QAP2E QAP2EL",
		"youtubeId": "WML-K43VxI0"
	},
	{
		"title": "Sentry®Safe Pistol Safes - Change Batteries",
		"category": "Self-Help",
		"tag": "Self-Help QAP1BE QAP1E QAP2E QAP2EL",
		"youtubeId": "N8RLGYvfyvY"
	},
	{
		"title": "Sentry®Safe Pistol Safes - Mount Your Safe",
		"category": "Self-Help",
		"tag": "Self-Help QAP1BE QAP1E QAP2E QAP2EL",
		"youtubeId": "RyWvTdejicQ"
	},
	{
		"title": "Sentry®Safe Pistol Safes - Change Interior Light Settings",
		"category": "Self-Help",
		"tag": "Self-Help QAP2EL",
		"youtubeId": "aLLZ4mRoOcI"
	},
	{
		"title": "Sentry®Safe Quick Access Pistol Safes",
		"category": "Products",
		"tag": "Products QAP1BE QAP1E QAP2E QAP2EL QAP2BEL PP1K",
		"youtubeId": "BXvaKvcjarA"
	},
	{
		"title": "Sentry®Safe PP1K Pistol Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products PP1K",
		"youtubeId": "jv0yBddFEmA"
	},
	{
		"title": "Sentry®Safe QAP1BE: Quick Access Biometric Pistol Safe",
		"category": "Products",
		"tag": "Products QAP1BE",
		"youtubeId": "z_L5bOoWHoQ"
	},
	{
		"title": "Sentry®Safe QAP1BE Pistol Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products QAP1BE",
		"youtubeId": "LGyuEvIXx7Y"
	},
	{
		"title": "Sentry®Safe QAP1E: Quick Access Electronic Pistol Safe",
		"category": "Products",
		"tag": "Products QAP1E",
		"youtubeId": "0IhMDxxjWfk"
	},
	{
		"title": "Sentry®Safe QAP1E Pistol Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products QAP1E",
		"youtubeId": "eMThFvcZ-Jo"
	},
	{
		"title": "Sentry®Safe QAP2E: XL Quick Access Electronic Pistol Safe",
		"category": "Products",
		"tag": "Products QAP2E",
		"youtubeId": "7dUT5DOGkfE"
	},
	{
		"title": "Sentry®Safe QAP2E Pistol Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products QAP2E",
		"youtubeId": "gYrUgxKVwnQ"
	},
	{
		"title": "Sentry®Safe QAP2EL: XL Quick Access Electronic Pistol Safe",
		"category": "Products",
		"tag": "Products QAP2EL",
		"youtubeId": "KpZFZ8JsIYs"
	},
	{
		"title": "Sentry®Safe QAP2EL Pistol Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products QAP2EL",
		"youtubeId": "1huyOGMN8cU"
	},
	{
		"title": "Sentry®Safe Fire/Water Resistant Digital Chest",
		"category": "Products",
		"tag": "Products CHW30300",
		"youtubeId": "UNRTV8RlBkI"
	},
	{
		"title": "Sentry®Safe Fire/Water Resistant Digital File Safe",
		"category": "Products",
		"tag": "Products FHW40300",
		"youtubeId": "jInS0-imtIw"
	},
	{
		"title": "Sentry®Safe CHW30300 Digital Chest: 360 Degree Overview",
		"category": "Products",
		"tag": "Products CHW30300",
		"youtubeId": "_XPmetVl9Ic"
	},
	{
		"title": "Sentry®Safe FHW40300 Digital File Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products FHW40300",
		"youtubeId": "y5807hWjiGI"
	},
	{
		"title": "Sentry®Safe Digital Chest/File - How to Change Batteries",
		"category": "Self-Help",
		"tag": "Self-Help CHW30300 FHW40300",
		"youtubeId": "VBAkXibIUQk"
	},
	{
		"title": "Sentry®Safe Digital Chest/File - How to Operate",
		"category": "Self-Help",
		"tag": "Self-Help CHW30300 FHW40300",
		"youtubeId": "6nBXTdhVOA0"
	},
	{
		"title": "Sentry®Safe Fire/Water Resistant Safe - Mount Your Safe",
		"category": "Self-Help",
		"tag": "Self-Help SF123CS SF123ES SF205CV SF205EV SFW082CTB SFW082D SFW082DTB SFW082ESB SFW082ET SFW082F SFW082FTC SFW082GTC SFW123BDC SFW123BSC SFW123BTC SFW123BUC SFW123CS SFW123CSB SFW123CTB SFW123CU SFW123DEB SFW123DSB SFW123DTB SFW123DUB SFW123ES SFW123EU SFW123FSC SFW123FTC SFW123FUL SFW123GDC SFW123GDF SFW123GSC SFW123GTC SFW123GTF SFW123TSC SFW123TTC SFW123UDC SFW123UTC SFW123UVC SFW205BPC SFW205BRC SFW205BWC SFW205BXC SFW205CWB SFW205CZB SFW205DPB SFW205EVB SFW205FWC SFW205FYC SFW205GPC SFW205GQC SFW205GRC SFW205TWC SFW205TXC SFW205UPC SFW205UQC SFW205URC STW123GDC STW123GTC STW205GYC",
		"youtubeId": "uLUk-SUaM0I"
	},
	{
		"title": "Sentry®Safe QAP2BEL: XL Quick Access Biometric Pistol Safe",
		"category": "Products",
		"tag": "Products QAP2BEL",
		"youtubeId": "z5j8_NaICFE"
	},
	{
		"title": "Sentry®Safe QAP2BEL Pistol Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products QAP2BEL",
		"youtubeId": "qvyiJ6C_oU4"
	},
	{
		"title": "Sentry®Safe Fire/Water Resistant Chest and File Safe",
		"category": "Products",
		"tag": "Products 0500 1200 1210 1160 1170 H0100 HD2100 HD4100 FHW40100 FHW40120 FHW40200 FHW40300 CHW20101 CHW20121 CHW20201 CHW20205 CHW20221 CHW30100 CHW30200 CHW30220 CHW30300 CFW20201 CFW30100 CFW30200",
		"youtubeId": "8gqKFqRLqiQ"
	},
	{
		"title": "Sentry®Safe Pistol Safe - How to Change LED Settings",
		"category": "Self-Help",
		"tag": "Self-Help QAP1BLX QAP2BLX",
		"youtubeId": "-e4RBeg5_ds"
	},
	{
		"title": "Sentry®Safe Pistol Safe - How to Program a New User Code",
		"category": "Self-Help",
		"tag": "Self-Help QAP1BLX QAP2BLX",
		"youtubeId": "IriKJLWbqys"
	},
	{
		"title": "Sentry®Safe Pistol Safe - How to Program a Primary Fingerprint",
		"category": "Self-Help",
		"tag": "Self-Help QAP1BLX QAP2BLX",
		"youtubeId": "YIhsw18pcV8"
	},
	{
		"title": "Sentry®Safe Pistol Safe - How to Program a Secondary Fingerprint",
		"category": "Self-Help",
		"tag": "Self-Help QAP1BLX QAP2BLX",
		"youtubeId": "fbJ5SUvgfIY"
	},
	{
		"title": "Sentry®Safe Pistol Safe - SentrySafe Quick Access Biometric Pistol Safe",
		"category": "Products",
		"tag": "Products QAP1BLX QAP2BLX",
		"youtubeId": "Cl1-MNPs7mM"
	},
	{
		"title": "SentrySafe QAP1BLX Pistol Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products QAP1BLX",
		"youtubeId": "Z5dNX2k6BH0"
	},
	{
		"title": "SentrySafe QAP2BLX Pistol Safe: 360 Degree Overview",
		"category": "Products",
		"tag": "Products QAP2BLX",
		"youtubeId": "dci3nezymDQ"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/support/videos/videoData.json
// module id = 693
// module chunks = 0